module.exports = __webpack_public_path__ + "static/Truck26-cddd23abf3f504b26bcb051a5a1c5ac4.png";